import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export default (function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.defaultText), {}, {
      borderRadius: '8px',
      display: 'flex',
      flexDirection: 'column',
      padding: '16px',
      '& .ReactCollapse--collapse': {
        width: '100%',
        minHeight: 20,
        overflow: 'hidden !important',
        transition: 'height 500ms',
        willChange: 'height'
      }
    }),
    wrap: {
      display: 'flex'
    },
    icon: {
      display: 'flex',
      marginRight: 10,
      marginTop: 1
    },
    Text: {
      display: 'block',
      width: '100%'
    },
    // Types
    default: {
      backgroundColor: theme.colors.neutral100,
      '& $Text': {
        color: theme.colors.neutral700
      },
      '& $dismiss': {
        color: "".concat(theme.colors.neutral700, " !important"),
        borderColor: "".concat(theme.neutral700, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.colors.neutral200, " !important")
        },
        '&:active': {
          backgroundColor: "".concat(theme.colors.neutral400, " !important")
        }
      }
    },
    error: {
      backgroundColor: theme.colors.red100,
      '& $Text': {
        color: theme.colors.red500
      },
      '& $dismiss': {
        color: "".concat(theme.colors.red500, " !important"),
        borderColor: "".concat(theme.colors.red500, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.colors.red200, " !important")
        },
        '&:active': {
          backgroundColor: "".concat(theme.colors.red400, " !important")
        }
      }
    },
    info: {
      backgroundColor: theme.colors.aqua100,
      '& $Text': {
        color: theme.colors.aqua700
      },
      '& $dismiss': {
        color: "".concat(theme.colors.aqua700, " !important"),
        borderColor: "".concat(theme.colors.aqua700, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.colors.aqua200, " !important")
        },
        '&:active': {
          backgroundColor: "".concat(theme.colors.aqua400, " !important")
        }
      }
    },
    success: {
      backgroundColor: theme.colors.green100,
      '& $Text': {
        color: theme.colors.green700
      },
      '& $dismiss': {
        color: "".concat(theme.colors.green700, " !important"),
        borderColor: "".concat(theme.colors.green700, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.colors.green200, " !important")
        },
        '&:active': {
          backgroundColor: "".concat(theme.colors.green400, " !important")
        }
      }
    },
    warning: {
      backgroundColor: theme.colors.yellow100,
      '& $Text': {
        color: theme.colors.yellow700
      },
      '& $dismiss': {
        color: "".concat(theme.colors.yellow700, " !important"),
        borderColor: "".concat(theme.colors.yellow700, " !important"),
        '&:hover': {
          backgroundColor: "".concat(theme.colors.yellow200, " !important")
        },
        '&:active': {
          backgroundColor: "".concat(theme.colors.yellow400, " !important")
        }
      }
    },
    textContainer: {
      flex: 1,
      overflow: 'hidden'
    },
    collapseContainer: {
      display: 'flex',
      overflow: 'hidden',
      alignItems: 'flex-start'
    },
    dropdownIcon: {
      marginTop: -4,
      lineHeight: '0',
      transition: 'transform 0.3s ease-out',
      willChange: 'transform',
      transform: 'rotate(0) translateY(1px)',
      cursor: 'pointer'
    },
    isOpened: {
      '& $dropdownIcon': {
        transform: 'rotate(-180deg) translateY(0px)'
      },
      '& $Text': {
        whiteSpace: 'pre-wrap'
      }
    },
    withTitleContainer: {
      marginTop: 15
    },
    dismiss: {
      alignSelf: 'flex-end',
      marginTop: 16
    }
  };
});